import { useSyncExternalStore } from 'react'
import type { Platform } from './platform'

/**
 * Тема нового интерфейса (этап 5 шаг 4): как в системе (в мини-приложениях -
 * как в мессенджере), светлая или тёмная. Выбор хранится на устройстве: это
 * удобство одного экрана, а не настройка аккаунта, на сервер не уходит.
 */
export type ThemeChoice = 'system' | 'light' | 'dark'

const KEY = 'procoach_theme_v2'
const listeners = new Set<() => void>()
/** Выбор в этой загрузке: если хранилище недоступно, действует до перезапуска. */
let memory: ThemeChoice | null = null

export function readThemeChoice(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY)
    return v === 'light' || v === 'dark' ? v : 'system'
  } catch {
    return 'system'
  }
}

export function setThemeChoice(choice: ThemeChoice) {
  try {
    if (choice === 'system') localStorage.removeItem(KEY)
    else localStorage.setItem(KEY, choice)
  } catch {
    // Хранилище недоступно (приватный режим): выбор остаётся в memory
  }
  memory = choice
  listeners.forEach((l) => l())
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

function snapshot(): ThemeChoice {
  return memory ?? readThemeChoice()
}

/** Выбор темы на этом устройстве; меняется сразу во всех экранах. */
export function useThemeChoice(): ThemeChoice {
  return useSyncExternalStore(subscribe, snapshot, () => 'system')
}

/** Какая тема на экране: выбранная или, при «как в системе», - среды. */
export function resolveScheme(choice: ThemeChoice, platform: Pick<Platform, 'colorScheme'>): 'light' | 'dark' {
  return choice === 'system' ? platform.colorScheme() : choice
}
